import React, { useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import routes from "routes.js";

import Box from "@mui/material/Box";

import AppSidebar from "components/Sidebar/Sidebar";
import AdminNavbar from "components/Navbars/AdminNavbar";
import Footer from "components/Footer/Footer";

import { DRAWER_WIDTH } from "theme/muiTheme";

const getActiveRoute = (routes) => {
  for (let i = 0; i < routes.length; i++) {
    const route = routes[i];
    if (route.collapse) {
      const sub = getActiveRoute(route.views);
      if (sub !== "Default Brand Text") return sub;
    } else if (route.category) {
      const sub = getActiveRoute(route.views);
      if (sub !== "Default Brand Text") return sub;
    } else if (window.location.href.indexOf(route.layout + route.path) !== -1) {
      return route.name;
    }
  }
  return "Default Brand Text";
};

const getRoutes = (routes) =>
  routes.map((prop, key) => {
    if (prop.collapse) return getRoutes(prop.views);
    if (prop.category === "configuracion") return getRoutes(prop.views);
    if (prop.category === "tesoreria") return getRoutes(prop.views);
    if (prop.layout === "/admin") {
      return (
        <Route
          path={prop.layout + prop.path}
          component={prop.component}
          key={key}
        />
      );
    }
    return null;
  });

export default function AdminLayout(props) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => setMobileOpen((prev) => !prev);
  const handleDrawerClose  = () => setMobileOpen(false);

  const brandText = getActiveRoute(routes);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>

      <AppSidebar
        routes={routes}
        mobileOpen={mobileOpen}
        onClose={handleDrawerClose}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          position: "relative",
          zIndex: 1,
          width: { xs: "100%", md: `calc(100% - ${DRAWER_WIDTH}px)` },
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <AdminNavbar
          onMenuClick={handleDrawerToggle}
          brandText={brandText}
        />

        <Box
          sx={{
            flexGrow: 1,
            px: { xs: 1, sm: 2, md: 3 },
            pb: 3,
          }}
        >
          <Switch>
            {getRoutes(routes)}
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
        </Box>

        <Footer />
      </Box>
    </Box>
  );
}
